import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";
import { catalogModuleClean, cleanSearchingCatalogModulesPaginated } from "../../app/actions/catalogModuleActions";

const NavbarIconsCatalogModules = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    if (icon === "new") {
      trackEvent({ component: "NewCatalogModules", event: "NewCatalogModules-Clicked" });
    } else if (icon === "list") {
      trackEvent({ component: "ListCatalogModules", event: "ListCatalogModules-Clicked" });
       dispatch(cleanSearchingCatalogModulesPaginated());
    }

    dispatch(catalogModuleClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogModules" && (
        <Link
          data-tip
          data-for="newCatalogModulesTip"
          to="/admin-catalog-module/new-catalog-module"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogModules" && (
        <Link
          data-tip
          data-for="listCatalogModulesTip"
          to="/admin-catalog-module/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogModules" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogModulesTip"
            to="/admin-catalog-module/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogModulesTip"
            to="/admin-catalog-module/new-catalog-module"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogModulesTip" place="left" effect="solid">
        {t("admin-catalog-module.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogModulesTip" place="left" effect="solid">
        {t("admin-calalog-module.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogModules;